import { Injectable } from '@angular/core';
import { AbstractWsService } from '../abstract-ws.service';
import { Observable, ReplaySubject } from 'rxjs';
import { PlayerActivityServiceCollection, PlayerActivityServiceWsDTO } from './player-activity-ws.model';

@Injectable({
  providedIn: 'root',
})
export class PlayerActivityWsService extends AbstractWsService<PlayerActivityServiceWsDTO> {
  private readonly alertsWsMessageSubject = new ReplaySubject<PlayerActivityServiceWsDTO>(1);

  protected getPath(): string {
    return '/player-activity/admin-ws';
  }
  protected onError(error: any): void {
    console.error('[PLAYER ACTIVITY WS] error:', error);
  }

  constructor() {
    super();
    this.subscribeToMessages();
  }

  public getAlertsWsMessageObservable(): Observable<PlayerActivityServiceWsDTO> {
    return this.alertsWsMessageSubject.asObservable();
  }

  private subscribeToMessages() {
    this.getMessagesObs().subscribe((msg) => this.handleMessage(msg));
  }

  private handleMessage(msg: PlayerActivityServiceWsDTO) {
    switch (msg.collection) {
      case PlayerActivityServiceCollection.ALERTS:
        this.handleAlertsMessage(msg);
        break;
    }
  }

  private handleAlertsMessage(msg: PlayerActivityServiceWsDTO) {
    this.alertsWsMessageSubject.next(msg);
  }
}
